import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";
const SvgQuestionmarkOutline = (props: SvgProps) => (
  <Svg width={24} height={24} fill="none" viewBox="0 0 36 36" {...props}>
    <Path
      fill={props.color}
      d="M36 18c0 9.941-8.059 18-18 18S0 27.941 0 18 8.059 0 18 0s18 8.059 18 18"
    />
    <Path
      fill="#90E2AC"
      d="M19.5 22.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M17.25 12a3.75 3.75 0 0 0-3.75 3.75h3a.75.75 0 0 1 .75-.75h.969a.573.573 0 0 1 .255 1.086l-1.974.987V19.5h3v-.573l.317-.159A3.573 3.573 0 0 0 18.219 12z"
    />
    <Path
      fill="#90E2AC"
      d="M6 18a12 12 0 1 1 24 0 12 12 0 0 1-24 0m12-9a9 9 0 1 0 0 18.001A9 9 0 0 0 18 9"
    />
  </Svg>
);
const Memo = memo(SvgQuestionmarkOutline);
export default Memo;
